var _rect, _path, _path2, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSafe(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 56,
    height: 56,
    rx: 18,
    fill: "#E9F2FF",
    fillOpacity: 0.07
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_101_38",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 18,
    y: 15,
    width: 21,
    height: 27
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36.0802 19.6533V20.64L31.3602 17.9067C29.5736 16.88 27.0802 16.88 25.3069 17.9067L20.5869 20.6533V19.6533C20.5869 16.6533 22.2269 15 25.2269 15H31.4402C34.4402 15 36.0802 16.6533 36.0802 19.6533Z",
    fill: "#292D32"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M36.12 22.96L35.9333 22.8667L34.12 21.8267L30.36 19.6534C29.2133 18.9867 27.4533 18.9867 26.3067 19.6534L22.5467 21.8134L20.7333 22.88L20.4933 23C18.16 24.5734 18 24.8667 18 27.3867V33.4134C18 35.9334 18.16 36.2267 20.5467 37.84L26.3067 41.16C26.88 41.5067 27.6 41.6534 28.3333 41.6534C29.0533 41.6534 29.7867 41.4934 30.36 41.16L36.1733 37.8C38.52 36.2267 38.6667 35.9467 38.6667 33.4134V27.3867C38.6667 24.8667 38.5067 24.5734 36.12 22.96ZM32.0533 30.3334L31.24 31.3334C31.1067 31.48 31.0133 31.76 31.0267 31.96L31.1067 33.24C31.16 34.0267 30.6 34.4267 29.8667 34.1467L28.68 33.6667C28.4933 33.6 28.1867 33.6 28 33.6667L26.8133 34.1334C26.08 34.4267 25.52 34.0134 25.5733 33.2267L25.6533 31.9467C25.6667 31.7467 25.5733 31.4667 25.44 31.32L24.6133 30.3334C24.1067 29.7334 24.3333 29.0667 25.0933 28.8667L26.3333 28.5467C26.5333 28.4934 26.76 28.3067 26.8667 28.1467L27.56 27.08C27.9867 26.4134 28.6667 26.4134 29.1067 27.08L29.8 28.1467C29.9067 28.32 30.1467 28.4934 30.3333 28.5467L31.5733 28.8667C32.3333 29.0667 32.56 29.7334 32.0533 30.3334Z",
    fill: "#292D32"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_101_38)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 13,
    width: 41,
    height: 30,
    fill: "#E9F2FF",
    fillOpacity: 0.5
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSafe);
export default __webpack_public_path__ + "static/media/safe.2eb643f2719adf49a7c9842318b65a76.svg";
export { ForwardRef as ReactComponent };